import api from "./axios";
import type { ShareCode, ShareCodeImportResult } from "@/types";
import { paths } from "./paths";

export const getShareCodes = () =>
  api.get<ShareCode[]>(paths.shareCodes.list).then((r) => r.data);

export const createShareCode = () =>
  api.post<ShareCode>(paths.shareCodes.list).then((r) => r.data);

export const applyShareCode = (code: string) =>
  api
    .post<ShareCodeImportResult>(paths.shareCodes.redemptions, { code })
    .then((r) => r.data);

export const deleteShareCode = (id: string) =>
  api.delete(paths.shareCodes.one(id)).then((r) => r.data);
